import React, { useState, useEffect } from 'react';
import { Box, Button, Text, useToast, Icon, Collapse } from '@chakra-ui/react';
import { FaBell } from 'react-icons/fa';
import axios from 'axios';

const PUBLIC_VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || 'BFpPLlYXFD3ERd8uz6Ibcbg_hz9eckW8IHnVx4tkpEJytymrnkwSCv-JUAiRV0lYPrF9R8daJIEbd-2MmonQN9I';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default function PushManager() {
  const [showPrompt, setShowPrompt] = useState(false);
  const toast = useToast();

  useEffect(() => {
    // Only show if push is supported and not already granted/denied
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      if (Notification.permission === 'default') {
        // Delay showing the prompt a bit so it's not aggressive
        const timer = setTimeout(() => setShowPrompt(true), 5000);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleSubscribe = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        setShowPrompt(false);
        return;
      }

      const registration = await navigator.serviceWorker.ready;
      
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
      });

      // Send subscription to backend
      const API_URL = process.env.REACT_APP_API_URL || 'https://salaevangelica.com/api';
      await axios.post(`${API_URL}/push/subscribe`, subscription);

      toast({
        title: '¡Suscrito!',
        description: 'Recibirás notificaciones de los nuevos devocionales y eventos.',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });

      setShowPrompt(false);
    } catch (error) {
      console.error('Error subscribing to push:', error);
      toast({
        title: 'Error',
        description: 'No se pudo activar las notificaciones.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // Podríamos guardar en localStorage que no quiere ver el prompt por un tiempo
    localStorage.setItem('hidePushPrompt', 'true');
  };

  if (!showPrompt || localStorage.getItem('hidePushPrompt') === 'true') {
    return null;
  }

  return (
    <Collapse in={showPrompt} animateOpacity>
      <Box
        position="fixed"
        bottom={{ base: "20px", md: "30px" }}
        right={{ base: "20px", md: "30px" }}
        left={{ base: "20px", md: "auto" }}
        bg="white"
        p={4}
        borderRadius="lg"
        boxShadow="xl"
        borderLeft="4px solid"
        borderColor="blue.500"
        zIndex={9999}
        maxWidth="350px"
      >
        <Box display="flex" alignItems="center" mb={2}>
          <Icon as={FaBell} color="blue.500" mr={2} />
          <Text fontWeight="bold" fontSize="sm">Notificaciones</Text>
        </Box>
        <Text fontSize="sm" mb={3} color="gray.600">
          Activa las notificaciones para avisarte cuando subamos un nuevo devocional o haya un aviso importante.
        </Text>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button size="sm" variant="ghost" onClick={handleDismiss}>
            Quizás luego
          </Button>
          <Button size="sm" colorScheme="blue" onClick={handleSubscribe}>
            Activar
          </Button>
        </Box>
      </Box>
    </Collapse>
  );
}
